require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/zhujian/Desktop/code/live_system/live/~/core-js/library/modules/es7.symbol.observable.js
// module id = 283
// module chunks = 0